// Import 3rd-party dependencies
import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { SubSink } from 'subsink';

// Import project-specific dependencies
import {
  DxcTimeNotificationService,
  IDxcTimeNotification
} from '@app/services/notifications/dxctime/dxctime-notification.service';
import { INotificationInfo } from '@app/services/notifications/notification.service';
import { UamNotificationService, IUamNotification } from '@app/services/notifications/uam/uam-notification.service';
import { NOTIFICATION_CARD_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.css']
})
export class NotificationCardComponent implements OnInit, OnDestroy {
  @Input() data: INotificationInfo;
  private subs: SubSink;
  consts = NOTIFICATION_CARD_COMPONENT_CONSTS;
  @Output() clearNotificationEvent: EventEmitter<string>;

  constructor(
      private dxcTimeNotificationService: DxcTimeNotificationService, 
      private uamNotificationService: UamNotificationService
    ) 
    {
      this.clearNotificationEvent = new EventEmitter<string>();
    }

  ngOnInit(): void {
    this.subs = new SubSink();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onClick(): void {
    // DXC Time notification
    if (this.data.title === this.consts.NOTIF_DXC_TIME) {
      const origObj = (this.data.origObj || null) as IDxcTimeNotification;

      if (origObj && !origObj.isRead) {
        this.subs.sink = this.dxcTimeNotificationService.markNotificationAsRead(origObj.id).subscribe();
      }
    }
    // UAM notification
    if (this.data.title === this.consts.NOTIF_UAM) {
      const origObj = (this.data.origObj || null) as IUamNotification;
      
      if (origObj && !origObj.isRead) {
        this.subs.sink = this.uamNotificationService.markUamNotificationAsRead(origObj.id).subscribe();
      }
    }
  }

  clearNotificatioin() {
    if (this.data.title === this.consts.NOTIF_DXC_HUB) {
      const disabledNotifList = JSON.parse(localStorage.getItem('DisabledNotifList')) || [];
      localStorage.setItem('DisabledNotifList', JSON.stringify([...disabledNotifList, this.data.announcementID]));
      this.clearNotificationEvent.emit();
    }
  }
}
